import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "../context/I18nContext";
import "./Auth.css";

export default function PendingVerification() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { t } = useTranslation();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <section className="auth-shell">
      <div className="auth-card">
        <h1>{t("verificationPage.title")}</h1>
        <p>{t("verificationPage.message")}</p>

        <div className="auth-actions">
          <button type="button" className="btn primary" onClick={handleLogout}>
            {t("verificationPage.logout")}
          </button>
        </div>
      </div>
    </section>
  );
}
